module.exports = __webpack_public_path__ + "img/cover-mini-vagues.92323614.jpg";